import React, { useState, useEffect } from "react";
import "./OurServices.css";
import "./../typography-home.css";
import bgImage from "./../../../assets/HomeSection/services-bg.png";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  englishData,
  sinhalaData,
  tamilData,
} from "../../../dummyData/HomeDummyData";

function OurServices() {
  const navigate = useNavigate();
  const selectedLanguage = useSelector((state) => state.language.language);
  const [language, setLanguage] = useState(sinhalaData[0]);

    useEffect(() => {
      switch (selectedLanguage.value) {
        case "english":
          setLanguage(englishData[0]);
          break;
        case "tamil":
          setLanguage(tamilData[0]);
          break;
        default:
          setLanguage(sinhalaData[0]);
          break;
      }

    }, [selectedLanguage]);

    const handleOpenLearners = () => {
      navigate("/find-and-register-driving-schools");
    };

  return (
    <section
      className="our-services-section text-center text-lg-start min-vh-80 d-flex align-items-center" alt='driving license related services in Sri Lanka'
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="overlay"></div>
      <div className="container position-relative py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <h2 className="fw-bold text-center mb-lg-4 mb-sm-2 mb-3 typography-title">
              {language.ServiceTitle}
            </h2>
            <h3 lassName="fw-semibold text-center mb-3 typography-subtitle">
              {language.ServiceSubTitle}
            </h3>
            <p className="text-muted text-cen er mb-4 typography-paragraph">
              {language.ServiceSubTitle2}
            </p>

            <div className="services-card py-4 px-2 shadow-sm rounded-4 mx-auto">
              <ul className="list-unstyled typography-list-item text-start my-lg-4 my-3 mx-lg-5 mx-xs-1 mx-3">
                <li>
                  • {language.ServicSubTopic1}
                </li>
                <li>
                  • {language.ServicSubTopic2}
                </li>
                <li>
                  • {language.ServicSubTopic3}
                </li>
                <li>
                  • {language.ServicSubTopic4}
                </li>
              </ul>
            </div>
            <div className="text-center pt-3">
              <button className="btn btn-danger px-4 py-2 fw-semibold join-dri-shl-btn" onClick={handleOpenLearners}>
                {language.ServiceBtn}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurServices;
